import "./PageLoader.css";
function PageLoader(){
    return (
        <div className="container">                        
            <div className="typing-container">CONNECTING TO RACETYP3 SERVERS...</div>
        </div>
    )
}

export default PageLoader;